<template>
  <div>
    <secondHeader />
    <div class="main">
      <sidebar />
      <div class="content">

        <h2><svg class="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"></path></svg>ご利用のルール</h2>
        <p>「はいしんツールキット」は「<a href="https://www.ruri.info/" target="_blank" rel="noopener noreferrer">ruri.info</a>」が運営する、ライブ配信活動のサポートツールです。</p>
        <p>商用利用OK。個人、法人問わず活動に利用できます。</p>
        <p>ご使用にあたり、報告やクレジット表記の義務はありません。</p>
        <p>不明点、リクエスト、ご質問などは開発者のTwitter(<a href="https://twitter.com/syou_config" target="_blank" rel="noopener noreferrer">@syou_config</a>  )まで遠慮なくご連絡ください！</p>
        <p>「こんなツールが欲しい！」とかも大歓迎です。</p>

        <div class="ad-block">
            <div class="ad">
              <InFeedAdsense
                  data-ad-layout-key="-fb+5w+4e-db+86"
                  data-ad-client="ca-pub-9016794589237931"
                  data-ad-slot="4898735474">
              </InFeedAdsense>
            </div>
          </div>
      </div>
    </div>

  </div>
</template>
<script>
import secondHeader from "../components/secondHeader.vue";
import sidebar from "../components/sidebar.vue"

export default {
  components: {
    secondHeader,
    sidebar,
  },
    data(){
      return{
        isProduction: process.env.NODE_ENV === "production",
      }
    }
};
</script>
<style scoped>
.main {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
  background: linear-gradient(-225deg, #acb6e5 0%, #fff 25%,#fff 75%, #FFBAC3 100%);
}
.content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 60px 0 60px 1.82%;
  margin: 0 auto;
  margin: 0 auto;
  max-width: 767px;
}
.icon{
    height: 1.5rem;
    line-height: 1.5em;
    vertical-align: middle;
    margin-right: 6px;
}
h2 {
  border-bottom: solid 3px #cbcbcb;
  position: relative;
  letter-spacing: 1px;
  line-height: 1.5em
}

h2:after {
  position: absolute;
  content: " ";
  display: block;
  border-bottom: solid 3px #004898;
  bottom: -3px;
  width: 20%;
}

.ad-block{
  padding: 24px 12px 0px 12px;
  display: block;
  width: 100%;
}
.ad {
  max-height: 300px;
  max-width: 70%;
  margin: 0 auto;
  text-align: center;
  box-sizing: border-box;
  display: block;
}
</style>